import { render, staticRenderFns } from "./InvestmentsConseq.vue?vue&type=template&id=f96ddeac&scoped=true"
import script from "./InvestmentsConseq.vue?vue&type=script&lang=js"
export * from "./InvestmentsConseq.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f96ddeac",
  null
  
)

export default component.exports